import { z } from 'zod';
import { SafetyViolationTypes } from '@shared/constants/safety.const';
import { SafetyEventStatuses } from '@shared/constants/statuses.const';
import { minimizedProfessionSchema } from '@shared/interfaces/IMinimizedProfession';
import { tradeSchema } from '@shared/interfaces/ITrade';
import { managerSchema } from '@shared/interfaces/IManager';

export const minimalSafetyEventForClientSchema = z.object({
	_id: z.string(),
	status: z.enum(SafetyEventStatuses),
	safetyViolationType: z.enum(SafetyViolationTypes),
	isCritical: z.boolean(),
	profession: minimizedProfessionSchema.nullable(),
	trade: tradeSchema.nullable(),
	manager: managerSchema.nullable(),
	floorNick: z.string().nullable(),
	floorId: z.string().nullable(),
	timestampCreated: z.number(),
	timestampClosed: z.number().nullable(),
	linkedIssueId: z.string().optional(),
});

export type IMinimalSafetyEventForClient = z.infer<typeof minimalSafetyEventForClientSchema>;
